import type { AssetItem } from '../redux/types';

export const getVehicleNameOfAssetId = (assetId: string | undefined, vehicles: AssetItem[]): string | undefined => {
    if (!assetId) {
        return undefined;
    }
    const foundVehicleByAssetId = vehicles.find(vehicle => vehicle.id === assetId);
    return foundVehicleByAssetId?.name;
};
